module.exports = __webpack_public_path__ + "img/search-header-with-nav-ford.57584049.png";